import Navigation from "./navigation";

interface DrawerContentProps {
  isOpen: boolean;
}

const DrawerContent = (props: DrawerContentProps) => (
  <Navigation isOpen={props.isOpen} />
);
export default DrawerContent;
